module.exports = __webpack_public_path__ + "static/media/cr.16dd5a64.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/objects/cr.svg
// module id = 1084
// module chunks = 36